module.exports = __webpack_public_path__ + "static/media/24.2555dbb5.jpeg";